<form [formGroup]="userPassForm" (ngSubmit)="onSubmit()" *ngIf="userPassForm && editMode" autocomplete="off">
  <div class="row g-3">
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">New Password</label>
      <div class="input-group">
        <input class="form-control"
               formControlName="pass"
               autocomplete="new-password"
               [type]="showPassword ? 'text' : 'password'"
               [class.is-invalid]="userPassForm.get('pass')?.errors && userPassForm.get('pass')?.touched">
        <span class="input-group-text bg-light border-start-0" style="cursor:pointer;" (click)="showPassword = !showPassword">
          <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
        </span>
        <div class="invalid-feedback" *ngIf="userPassForm.get('pass')?.touched && userPassForm.get('pass')?.hasError('required')">
          Password is required
        </div>
        <div class="invalid-feedback" *ngIf="userPassForm.get('pass')?.touched && userPassForm.get('pass')?.hasError('minlength')">
          Password must be at least 6 characters
        </div>
      </div>
    </div>
    <div class="col-12 col-md-6">
      <label class="form-label fw-semibold">Confirm Email</label>
      <input type="email" class="form-control" formControlName="email1" readonly autocomplete="off">
    </div>
    <div class="col-12">
      <button type="submit" class="btn btn-warning me-2" [disabled]="!userPassForm.valid">
        <i class="fa fa-key me-1"></i>
        Update Password
      </button>
      <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
        <i class="fa fa-times me-1"></i>
        Cancel
      </button>
    </div>
  </div>
</form>
<div *ngIf="!editMode" class="text-center py-3">
  <p class="text-muted mb-0">
    <i class="fa fa-shield-alt me-2"></i>
    Click "Change Password" to update the user's password
  </p>
</div>
